import { BlockType } from "@jackfruit/common"
import { orderBy } from "lodash"
import { useBlocks } from "./useBlocks"
import { actionableToBlocks } from "./useNextActionableBlock"

const minimumActionableBlocks: BlockType[] = [
  "image-upload",
  "template",
  "product-grid",
]

export const usePreviousActionableBlock = (currentBlock: BlockType) => {
  const { blocks } = useBlocks()

  const sortedBlocks = orderBy(blocks, ["order"], ["asc"])

  const currentBlockIndex = sortedBlocks.findIndex(
    block => block.type === currentBlock
  )

  const previousActionableBlocks = sortedBlocks.find(
    (b, i) =>
      i < currentBlockIndex &&
      currentBlock !== b.type &&
      actionableToBlocks.includes(b.type)
  )

  const hasMinimumActionableBlockRequirement = !!sortedBlocks.find(b =>
    minimumActionableBlocks.includes(b.type)
  )

  const previousBlockType = previousActionableBlocks?.type!

  return {
    previousBlockType,
    hasMinimumActionableBlockRequirement,
  }
}
